import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useGiftCardsCategoriesSelector = () => useSelector((state: StateExtended) => state.giftCards.categories);

export const useGeneralGiftCardsSelector = () =>
    useSelector((state: StateExtended) => state.giftCards.generalGiftCards);
